import script from "./SystemStateCounters.vue?vue&type=script&lang=ts&setup=true"
export * from "./SystemStateCounters.vue?vue&type=script&lang=ts&setup=true"

import "./SystemStateCounters.vue?vue&type=style&index=0&id=2096c5cf&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2096c5cf"]])

export default __exports__